"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrailShader = void 0;
const fragmentSrc = `#ifdef GL_ES
precision highp float;
#endif

varying vec4 vColor;
uniform float pointMode;

void main(void) {
  // Marker geometry is rendered as actual triangles. Only trail points use
  // gl_PointCoord and the round, shaded billboard treatment.
  if (pointMode < 0.5) {
    gl_FragColor = vColor;
    return;
  }
  vec2 coord = gl_PointCoord - vec2(0.5);
  float dist = length(coord);
  if (dist > 0.5) discard;
  // A small radial highlight gives the billboard the appearance of a sphere.
  float shade = 0.55 + 0.45 * sqrt(max(0.0, 1.0 - 4.0 * dist * dist));
  gl_FragColor = vec4(vColor.rgb * shade, vColor.a);
}`;
const vertexSrc = `#ifdef GL_ES
precision highp float;
#endif

attribute vec3 position;
attribute vec4 color;
attribute float size;

uniform mat4 viewMatrix;
uniform mat4 projectionMatrix;
uniform float pointScale;

varying vec4 vColor;

void main(void) {
  vec4 viewPos = viewMatrix * vec4(position, 1.0);
  gl_Position = projectionMatrix * viewPos;
  // Size is in GoldSrc world units. Scaling by camera distance makes the
  // point behave as a world-space billboard instead of a viewport-size dot.
  float viewDistance = max(1.0, -viewPos.z);
  gl_PointSize = clamp(size * pointScale / viewDistance, 1.0, 64.0);
  vColor = color;
}`;
class TrailShader {
    static init(context) {
        const shader = context.createProgram({
            vertexShaderSrc: vertexSrc,
            fragmentShaderSrc: fragmentSrc,
            attributeNames: ['position', 'color', 'size'],
            uniformNames: ['viewMatrix', 'projectionMatrix', 'pointScale', 'pointMode']
        });
        if (!shader)
            return null;
        return new TrailShader(shader);
    }
    constructor(shader) {
        this.shader = shader;
    }
    useProgram(context) {
        context.gl.useProgram(this.shader.handle);
    }
    setViewMatrix(context, matrix) {
        context.gl.uniformMatrix4fv(this.shader.uniforms['viewMatrix'], false, matrix);
    }
    setProjectionMatrix(context, matrix) {
        context.gl.uniformMatrix4fv(this.shader.uniforms['projectionMatrix'], false, matrix);
    }
    setPointScale(context, projectionMatrix) {
        const scale = context.gl.drawingBufferHeight * projectionMatrix[5] * 0.5;
        context.gl.uniform1f(this.shader.uniforms['pointScale'], scale);
    }
    setPointMode(context, enabled) {
        context.gl.uniform1f(this.shader.uniforms['pointMode'], enabled ? 1 : 0);
    }
    getAttribLocation(name) {
        return this.shader.attributes[name];
    }
}
exports.TrailShader = TrailShader;
